import { createSupabaseClient } from "../../../hooks/useSupabase";
import { appointmentRequest } from "./constants";
import { Appointment } from "./types";

const getAppointmentData = async (appointmentId: string) => {
  const supabaseClient = createSupabaseClient();

  const { data, error } = await supabaseClient
    .from("appointments")
    .select(appointmentRequest as string)
    .eq("id", appointmentId)
    .is(
      "appointment_offerings.appointment_package_id" as keyof Appointment,
      null,
    )
    .is("appointment_add_ons.appointment_package_id" as keyof Appointment, null)
    .is(
      "appointment_add_ons.appointment_offering_id" as keyof Appointment,
      null,
    )
    .not("appointment_payments.confirmed_at" as keyof Appointment, "is", null)
    .not(
      "appointment_patient_details.patient_id" as keyof Appointment,
      "is",
      null,
    )
    .limit(1)
    .limit(1, { foreignTable: "center.center_configs" })
    .limit(1, { foreignTable: "appointment_receipts" })
    .limit(1, { foreignTable: "appointment_ai_reports" })
    .order("id", {
      referencedTable: "appointment_packages.appointment_offerings",
      ascending: false,
    })
    .order("id", {
      referencedTable: "appointment_offerings",
      ascending: false,
    })
    .order("created_at", {
      referencedTable: "appointment_refunds",
      ascending: false,
    })
    .order("created_at", {
      referencedTable: "appointment_notes",
      ascending: false,
    })
    .single<Appointment>();

  if (error) throw new Error(error.message);

  return data;
};

export default getAppointmentData;
